<template>
  <div class="vermieter">

    <v-container fluid
                 class="pa-0">
      <v-row no-gutters>

        <v-col cols="12"
               md="4"
               :class="{'mb-4': $vuetify.breakpoint.smAndDown}">

          <v-checkbox v-model="vermselected"
                      color="primary"
                      class="pa-0"
                      hide-details>

            <template slot="label">

              <v-row no-gutters
                     align="center"
                     class="flex-nowrap">
                 <span class="mylabel mr-1">
                  Vermietete Wohneinheit(en)
                </span>

                <site-tooltip>
                  Sollten Sie mehr als 5 Wohneinheiten versichern wollen oder übersteigt die Jahresbruttomiete 24.000 €, ist eine Direktionsanfrage notwendig.
                </site-tooltip>
              </v-row>

            </template>

          </v-checkbox>

        </v-col>

        <v-col cols="12"
               md="8"
               class="center">
          <v-row v-if="vermselected" no-gutters>

            <template v-for="(wohnung, index) of vermwohnungen">

                <v-col :key="`flex${index}`"
                       cols="12"
                       class="wohnung">

                  <zusatz-vermieter-wohnung :key="'wohnung' + index"
                                            :wohnungen-index="index"
                                            :remove="index===vermwohnungen.length-1 && index!==0"
                                            :state-path="statePath + '.vermwohnungen.' + index"
                                            @vermieterwohnungdelete="removeWohnung"/>
                </v-col>

            </template>

            <v-col cols="12" class="pa-0 ma-0 btn-add-container">
              <div v-if="vermselected && vermwohnungen.length < 5"
                   class="btn-add"
                   @click="addWohnung">
                <v-icon>add</v-icon>
                <span>Wohneinheit hinzufügen</span>
              </div>
            </v-col>

          </v-row>
        </v-col>

      </v-row>
    </v-container>

  </div>
</template>

<script>
import KeyTranslator from "@/components/helper/keyTranslatorMixin";
import ValidationMixin from "@/components/helper/ValidationMixin";
import ZusatzVermieterWohnung from "@/components/privatkundenrechner/ZusatzVermieterWohnung";
import {mapTwoWay} from "@/store/twowayBindingMixin";
import twowayBinding from "@/store/twowayBindingMixin";

export default {
  components: { ZusatzVermieterWohnung },
  mixins: [twowayBinding, ValidationMixin, KeyTranslator],
  computed: {
    ...mapTwoWay([
      "vermselected",
      "vermwohnungen"
    ])
  },
  methods: {
    addWohnung() {
      this.$store.commit("addInitialWohnung", {rootState: this.$store.state, statePath: this.statePath});
    },
    removeWohnung() {
      this.$store.commit("removeWohnung", {rootState: this.$store.state, statePath: this.statePath});
    }
  }
};
</script>

<style>
.vermieter .v-icon {
  cursor: pointer;
}

.vermieter .center {
  margin-left: auto;
  margin-right: auto;
}

.vermieter .mylabel {
  font-size: 16px;
  white-space: nowrap;
}
.vermieter .v-input--checkbox > label {
  max-width: 100% !important;
  width: 100% !important;
}
.vermieter .btn-add-container {
  display: flex;
  justify-content: center;
}
.vermieter .btn-add {
  border: none !important;
  margin: 16px 0 0 0 !important;
  font-size: 16px;
  height: 36px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: fit-content;
}
.vermieter .btn-add .v-icon, .vermieter .btn-add span {
  color: rgba(0,0,0,.87);
  cursor: pointer;
}
.vermieter .btn-add:hover .v-icon, .vermieter .btn-add:hover span  {
  color: #0085CF!important;
}
.vermieter .wohnung+.wohnung {
  margin-top: 16px;
}
</style>


